import React, { useState, useRef } from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { GradientColorHeader } from "@curves/ui-shared";
import useInBodyApi from "@apis/useInBodyApi";
import { Button, Stack, TextField, Box } from "@curves/ui-base";
import { EmployeeSelect } from "@icoach/components/";
import { refIsRequiredError } from "@util/utils";
import inBodyImage from "@icoach/assets/img/image-7.png";
import { useInBodyContext } from "@icoach/inbody/components/InBodyContext";
import useGetEmployeeOptionState from "@util/hook/useGetEmployeeOptionState";

const InBodyInterviewNotMeasureDialog = React.forwardRef((props, ref) => {
	const { peopleID, refresh } = useInBodyContext();
	const { postInterViewNotMeasureDataApi } = useInBodyApi();
	const { employeeOption } = useGetEmployeeOptionState();
	const [openDialog, setOpenDialog] = useState(false);
	const employeeIDRef = useRef(null);
	const interviewContentRef = useRef(null);

	const handleOpenDialogOnClock = () => {
		setOpenDialog(true);
	};

	const handleConfirmClick = () => {
		if (!refIsRequiredError(employeeIDRef, interviewContentRef)) {
			postInterviewDataApi(
				{
					measureID: 0,
					interviewEmployeeID: employeeIDRef.current.getResult(),
					interviewContent: interviewContentRef.current.getResult(),
				},
				peopleID,
			);
		}
	};

	const postInterviewDataApi = async (params, pID) => {
		const resp = await postInterViewNotMeasureDataApi(params, pID);
		if (resp) {
			setOpenDialog(false);
			if (typeof refresh === "function") refresh();
		}
	};

	return (
		<React.Fragment>
			<Button className={"measure-weight-button"} variant="contained" onClick={handleOpenDialogOnClock}>
				<React.Fragment>
					<Box component={"img"} src={inBodyImage} />
					進行面談
				</React.Fragment>
			</Button>
			<Dialog open={openDialog} PaperProps={{ className: "wx-65rem" }} fullWidth>
				<GradientColorHeader onClose={() => setOpenDialog(false)}>新增面談</GradientColorHeader>
				<DialogContent>
					<Stack direction="column" spacing={2}>
						<EmployeeSelect ref={employeeIDRef} options={employeeOption} label="擔當教練" required />
						<TextField ref={interviewContentRef} label="面談內容" rows={10} multiline required />
					</Stack>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleConfirmClick} variant="contained">
						送出
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
});

export default InBodyInterviewNotMeasureDialog;
